import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function rolesReducer(state = initialState.roles, action: any) {
  switch (action.type) {
    case types.SAVE_ROLES_SUCCESS:
      return action.roles;
    default:
      return state;
  }
}
